export default __webpack_public_path__ + "static/layout-anatomy-dark-c058cfb5c92103da289802a1cfb3113e36257675d1f9f864dcb3842b126ec206.png";